/* LEVEL entourage-effect animated Venn.
   Drop <div id="level-entourage"></div> into an article body (e.g. under
   "How the three classes work together"). Three brand-colored circles animate
   in one after another, then the Entourage Effect reveals in the center.
   Hover / tap a circle (or its label) to reveal what that class contributes.
   Plays when scrolled into view; replay button re-runs it. Self-guards. */
(function(){
  function init(){
    var root=document.getElementById('level-entourage');
    if(!root || root.dataset.entInit==='1') return;
    root.dataset.entInit='1';
    root.classList.add('ent');

    // Three-circle Venn geometry (viewBox 520 x 470).
    var CLASSES=[
      {k:"fla", cls:"c1", lbl:"l1", name:"Flavonoids",   cx:198, cy:188, fill:"#ffb548", ring:"#c9871c",
       info:"The colour &amp; protection layer. Pigments and antioxidant compounds — including the cannflavins unique to hemp — thought to help round out the whole."},
      {k:"ter", cls:"c2", lbl:"l2", name:"Terpenoids",   cx:322, cy:188, fill:"#f68d6c", ring:"#dd6544",
       info:"The aroma layer (terpenes are the best-known members). The same aromatic oils found in citrus, pine and lavender — they shape scent and are believed to steer the character of each experience."},
      {k:"can", cls:"c3", lbl:"l3", name:"Cannabinoids", cx:260, cy:292, fill:"#19bde8", ring:"#1391b4",
       info:"The headline act. CBD, CBG, CBN and the rest — the cannabinoids that interact with the body&rsquo;s endocannabinoid system."}
    ];
    var R=132;
    var DEFAULT_CAP='On their own, each class does a little. Together &mdash; cannabinoids, terpenoids and flavonoids working in concert &mdash; they add up to more than the sum of their parts. <em>Hover or tap a circle to see each one&rsquo;s role.</em>';

    var circles=CLASSES.map(function(c){
      return '<circle class="ent__circle '+c.cls+'" data-k="'+c.k+'" cx="'+c.cx+'" cy="'+c.cy+'" r="'+R+'" '+
             'fill="'+c.fill+'" style="mix-blend-mode:multiply;--ring:'+c.ring+'"></circle>';
    }).join('');
    var labels=CLASSES.map(function(c){
      var lx=c.k==="fla"?140:(c.k==="ter"?380:260), ly=c.k==="can"?392:150;
      return '<g class="ent__olabel '+c.lbl+'" data-k="'+c.k+'" tabindex="0" role="button" '+
             'aria-label="'+c.name+', what it contributes"><text x="'+lx+'" y="'+ly+'" text-anchor="middle">'+c.name+'</text></g>';
    }).join('');

    root.innerHTML =
      '<span class="ent__eyebrow">The Entourage Effect</span>'+
      '<div class="ent__stage">'+
        '<svg class="ent__svg" viewBox="0 0 520 470" role="img" '+
             'aria-label="Venn diagram: flavonoids, terpenes and cannabinoids overlap to create the entourage effect">'+
          '<g style="isolation:isolate">'+ circles +'</g>'+
          labels+
          '<g class="ent__center">'+
            '<text class="ent__ctitle" x="260" y="216" text-anchor="middle">Entourage</text>'+
            '<text class="ent__ctitle" x="260" y="242" text-anchor="middle">Effect</text>'+
          '</g>'+
        '</svg>'+
      '</div>'+
      '<p class="ent__cap" data-cap>'+DEFAULT_CAP+'</p>'+
      '<button class="ent__replay" type="button" aria-label="Replay animation">'+
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/></svg>'+
        'Replay</button>';

    var cap=root.querySelector('[data-cap]');
    var circleEls=Array.prototype.slice.call(root.querySelectorAll('.ent__circle'));
    var labelEls=Array.prototype.slice.call(root.querySelectorAll('.ent__olabel'));
    function byK(k){return CLASSES.filter(function(c){return c.k===k;})[0];}

    var locked=null;
    function show(k){
      var c=byK(k);
      circleEls.forEach(function(el){el.classList.toggle('hot',el.dataset.k===k);});
      labelEls.forEach(function(el){el.classList.toggle('hot',el.dataset.k===k);});
      root.classList.add('dim');
      cap.innerHTML='<strong>'+c.name+'</strong> &mdash; '+c.info;
    }
    function reset(){
      circleEls.forEach(function(el){el.classList.remove('hot');});
      labelEls.forEach(function(el){el.classList.remove('hot');});
      root.classList.remove('dim');
      cap.innerHTML=DEFAULT_CAP;
    }
    function enter(k){ if(locked===null) show(k); }
    function leave(){ if(locked===null) reset(); }
    function toggle(k){ if(locked===k){ locked=null; reset(); } else { locked=k; show(k); } }

    circleEls.concat(labelEls).forEach(function(el){
      var k=el.dataset.k;
      el.addEventListener('mouseenter',function(){enter(k);});
      el.addEventListener('mouseleave',leave);
      el.addEventListener('click',function(){toggle(k);});
      el.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle(k);} });
      el.addEventListener('focus',function(){enter(k);});
      el.addEventListener('blur',leave);
    });

    function play(){
      root.classList.add('no-anim');
      root.classList.remove('play');
      void root.offsetWidth;
      root.classList.remove('no-anim');
      void root.offsetWidth;
      root.classList.add('play');
    }
    root.querySelector('.ent__replay').addEventListener('click',play);

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if(reduce){ root.classList.add('play'); return; }

    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ play(); io.disconnect(); } });
      },{threshold:.4});
      io.observe(root);
    } else { play(); }
  }

  if(document.readyState==="loading"){ document.addEventListener("DOMContentLoaded",init); }
  else { init(); }
})();
